<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">个性化设置</h3>
    <div>
      <p style="margin-bottom: 24px;">大屏轮播图设置（请上传宽高一致的一组轮播图片）</p>
      <div>
        <el-button type="primary" @click="(centerDialogVisible=true)">设 置</el-button>
      </div>
      <div class="flex-div">
        <el-card v-for="item in swipes" :key="item.id" :body-style="{ padding: '10px' }">
          <el-image fit="cover" style="height: 150px; width:300px;" :src="item.file" :preview-src-list="srcList">
          </el-image>
          <div style="padding: 8px;">
            <div class="bottom clearfix" style="text-align: center;">
              <el-button type="text" @click="handleDelete(item.id)" class="button"><i class="el-icon-delete" style="font-size: 22px;;"></i></el-button>
            </div>
          </div>
        </el-card>
      </div>
      <!-- <Uploadd ref="uploadd" :action="action" :params="params" @setFileList="setUpFileList" @delFile="delUpFile" :btnTitle="btnTitle"></Uploadd> -->
      <el-dialog :close-on-click-modal="false" title="轮播图设置" :visible.sync="centerDialogVisible" width="686px">
        <el-form ref="ruleForm" label-width="80px" class="demo-ruleForm">
          <el-form-item label="附件上传">
            <Uploadd ref="uploadd" :action="action" :params="params" @setFileList="setUpFileList" @delFile="delUpFile" :btnTitle="btnTitle"></Uploadd>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;margin-bottom: 0;">
            <el-button type="primary" @click="setBanner">设置</el-button>
            <el-button @click="centerDialogVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mixinUpload } from '@/assets/js/mixin/upload';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinRichtext } from '@/assets/js/mixin/richText';

export default {
  name: 'notice',
  mixins: [mixinUpload, mixinOrgan, mixinRichtext],
  data() {
    return {
      formInline: {
        user: '',
        region: '',
        date: '',
      },
      ruleForm: {
        file: '',
      },
      centerDialogVisible: false,
      detailDialogVisible: false,
      params: {
        school_id: '',
        type: 'notice',
      },
      fileTypee: 'notice',
      vHtml: '',
      btnTitle: '点击上传轮播图',
      swipes: [],
      srcList: [],
    };
  },
  components: {},
  created() {
    this.getBanners();
  },
  mounted() {},
  methods: {
    async getBanners() {
      let params = {};
      let res = await this.$api.instance.interfaceServer(`api/banner`, 'get', params);
      if (res.code == 0) {
        this.swipes = res.data;
        this.srcList = res.data.map((item) => {
          return item.file;
        });
      }
    },
    handleDelete(id) {
      this.confirmBox('warning', `此操作将删除该图片，是否继续`, { id }, this.deleteItem);
    },
    async deleteItem(params) {
      let res = await this.$api.instance.interfaceServer(`api/banner/deleteBanner`, 'post', { id: params.id });
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.getBanners();
      }
    },
    confirmBox(type, title, params, $fun) {
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type,
      })
        .then(() => {
          $fun(params);
        })
        .catch(() => {
        });
    },
    async setBanner() {
      let params = {};
      if (this.fileList.length) {
        params.file = this.fileList.join(',');
      }
      let res = await this.$api.instance.interfaceServer(`api/banner/setBanner`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.$refs.uploadd.clearFiles();
        this.centerDialogVisible = false;
        this.fileList = [];
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
.flex-div {
  margin-top:20px;
  display: flex;
  flex-wrap: wrap;
}
</style>
